export default "__VITE_ASSET__C_Ae7jKw__"